import React from "react";
import { legal } from "../mock";
import { Section, Footer } from "./Landing";
import { Button } from "../components/ui/button";
import { useSEO, SEO_PRESETS } from "@/hooks/useSEO";

const LegalHeader = () => {
  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-white/80 backdrop-blur-xl supports-[backdrop-filter]:bg-white/60 shadow-sm">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <div className="flex items-center gap-3">
          <div className="relative">
            <img 
              src="https://customer-assets.emergentagent.com/job_tech-support-mvp/artifacts/88uemucq_LogoKlartech%20%281%29.png" 
              alt="Klartech Müritz Logo" 
              className="h-12 w-auto object-contain transition-transform hover:scale-105"
            />
            <div className="absolute -right-1 -top-1 h-3 w-3 rounded-full bg-green-500 animate-pulse ring-2 ring-white"></div>
          </div>
        </div>
        <nav className="flex items-center gap-8">
          <Button
            onClick={() => window.location.href = '/'}
            className="relative rounded-xl bg-gradient-to-r from-primary to-blue-600 px-6 py-2.5 text-white shadow-lg transition-all hover:shadow-xl hover:scale-105 group overflow-hidden"
          >
            <span className="relative z-10 font-semibold">← Zur Startseite</span>
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-primary opacity-0 transition-opacity group-hover:opacity-100"></div>
          </Button>
        </nav>
      </div>
    </header>
  );
};

export default function Datenschutz() {
  // SEO für Datenschutz
  useSEO(SEO_PRESETS.datenschutz);
  
  const ds = legal.datenschutz;

  return (
    <div className="min-h-screen bg-white text-slate-900">
      <LegalHeader />
      <Section id="datenschutz" className="pt-10">
        <h1 className="text-3xl font-extrabold tracking-tight">Datenschutzerklärung</h1>
        <div className="prose prose-slate mt-6 max-w-none">
          {ds.sections.map((s) => (
            <div key={s.h} className="mb-6">
              <h3>{s.h}</h3>
              <p>{s.p}</p>
            </div>
          ))}
        </div>
      </Section>
      <Footer />
    </div>
  );
}
